import { FC } from "react";
import styled from "styled-components";
import { Col, Row } from "antd";
import ContactDetailsCardLoader from "modules/Analytics/Contacts/Loaders/ContactDetailsCardLoader";
import GraphLoader from "modules/Analytics/Contacts/Loaders/GraphLoader";
import CampaignsSubscribedLoader from "modules/Analytics/Contacts/Loaders/CampaignsSubscribedLoader";

interface IContactsDashboardLoader {
  loading?: boolean;
}

const ContactsDashboardLoader: FC<IContactsDashboardLoader> = (props: IContactsDashboardLoader) => {
  return (
    <>
      {props.loading && (
        <Wrapper>
          <Row gutter={24}>
            <Col span={8}>
              <ContactDetailsCardLoader />
            </Col>
            <Col span={16}>
              <CampaignsSubscribedLoader />
            </Col>
          </Row>
          <Row gutter={24} className="my-4">
            <Col span={8}>
              <GraphLoader />
            </Col>
            <Col span={8}>
              <GraphLoader />
            </Col>
            <Col span={8}>
              <GraphLoader />
            </Col>
          </Row>
        </Wrapper>
      )}
    </>
  );
};

export default ContactsDashboardLoader;

const Wrapper = styled.div`
  float: left;
  width: 100%;
  display: block;
  margin-top: 15px;
`;
